// 法务概况
import request from '@/router/axios';

// 列表
export const getList = (current, size, params) => {
  return request({
    url: '/api/blade-loanLegalAffairs/loanLegalAffairs/general_situation_page',
    method: 'post',
    data: {
      ...params,
      current,
      size,
    },
  });
};